module.exports = __webpack_public_path__ + "img/boy-flag-raise.c9bce7e2.png";